<template lang="pug">
  div
    //- Profile items
    .d-flex
      .mr-8
        //- Profile image
        v-img.round-xl(v-if="profileImage && profileImage.file" width="60" height="80" :src="profileImage.file" cover)
          template(v-slot:placeholder)
            v-row(class="fill-height ma-0" align="center" justify="center")
              v-progress-circular(indeterminate color="grey")
        v-card.neutral300.fill-height.round-xl(v-else flat width="60" height="80")
          div.d-flex.align-center.justify-center.fill-height
            v-icon(size="30") $yzi-user-03
      //- Profile info
      div.mt-3
        .text-lg.font-semibold {{ name }}
        .text-sm(v-if="dob") {{ $options.filters.getAgeByYearMonthDay(dob) | displayAgeByYearMonthDay }} old
    //- Analytics
    v-card.pa-4.rounded-lg.mt-6.neutral200.analytic-border(outlined)
      v-row(no-gutters)
        v-col.text-center
          .text-xs.neutral500--text {{ $t('total_spend') }}
          .text-sm {{ lifeTimeValue | displayPrice }}
        v-divider(vertical)
        v-col.text-center
          .text-xs.neutral500--text {{ $t('total_visit') }}
          .text-sm {{ totalVisit }}
    //- Patient details
    div.mt-8
      template(v-for="detail in detailItems")
        .mb-3
          .text-sm.neutral500--text.font-semibold {{ detail.text }}
          .text-sm
            span(v-if="detail.value") {{ detail.value }}
            span(v-else) -
</template>

<script>
import {DateTime} from 'luxon'

export default {
  props: {
    profileImage: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    ic: {
      type: String,
      default: null
    },
    dob: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    phone: {
      type: String,
      default: null
    },
    gender: {
      type: String,
      default: null
    },
    address: {
      type: Object,
      default: null
    },
    lifeTimeValue: {
      type: Number,
      default: null
    },
    totalVisit: {
      type: Number,
      default: null
    },
  },
  computed: {
    detailItems() {
      return [
        {
          text: 'ID number/passport',
          value: this.ic,
        },
        {
          text: 'Email',
          value: this.email,
        },
        {
          text: 'Phone number',
          value: this.phone,
        },
        {
          text: 'Birthday',
          value: this.displayDate(this.dob),
        },
        {
          text: 'Gender',
          value: this.gender,
        },
        {
          text: 'Address',
          value: this.getAddressInString(this.address),
        },
      ]
    }
  },
  methods: {
    displayDate(value) {
      if (!value) {
        return null
      }
      const date = DateTime.fromISO(value)
      return `${date.toFormat('dd MMM yyyy')}`
    },
    getAddressInString(addr) {
      if (!addr) {
        return null
      }
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      }
      if (addr.address_2) {
        address += `, ${addr.address_2}`
      }
      if (addr.postcode) {
        address += `, ${addr.postcode}`
      }
      if (addr.city) {
        address += `, ${addr.city}`
      }
      if (addr.state) {
        address += `, ${addr.state}`
      }
      if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
  }
}
</script>

<style scoped>
.analytic-border {
  border: 1px var(--v-neutral400) solid !important;
}
</style>